/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TikTokCreatorInfoDto } from '../models/TikTokCreatorInfoDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TikTokService {
    /**
     * Query the connected TikTok creator's posting options (creator_info)
     * @returns TikTokCreatorInfoDto
     * @throws ApiError
     */
    public static tikTokControllerGetCreatorInfoV1(): CancelablePromise<TikTokCreatorInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/tiktok/creator-info',
            errors: {
                400: `TikTok not connected or refused the query`,
            },
        });
    }
}
